<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Info', route: '/backoffice/info/' }, { label: 'Modifica Info', active: true }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">MODIFICA INFO</h1>
</section>


<section class="pb-16 mb-8 px-container">
    <form [formGroup]="formInfo" (ngSubmit)="onSubmit()">    
        <div class="flex lg:flex-row flex-col gap-8 mt-8">
            <div *ngFor="let contenuto of info?.items" class="flex flex-col gap-8" [ngClass]="{'w-full': info?.items!.length == 1, 'w-1/2': info?.items!.length != 1}">
                <div class="w-full">
                    <label>* Titolo</label>
                    <input type="text" pInputText placeholder="Titolo" [formControlName]="'titolo_' + contenuto.id" />
                    <small class="text-red-600 block mt-4 font-medium" *ngIf="formInfo.get('titolo_' + contenuto.id)?.hasError('required') && (formInfo.get('titolo_' + contenuto.id)?.dirty || formInfo.get('titolo_' + contenuto.id)?.touched)">Il titolo è obbligatorio!.</small>
                </div>
                <div class="w-full">
                    <label>Descrizione</label>
                    <p-editor [style]="{ height: '150px' }" [formControlName]="'descrizione_' + contenuto.id" />
                </div>
                <div class="flex lg:flex-row flex-col-reverse gap-8 items-center">
                    <div class="lg:w-1/2 w-full"></div>
                    <div class="lg:w-1/2 w-full text-end">
                        <button class="btn-danger-backoffice p-3 w-full font-medium" [ngClass]="{'lg:w-1/2': info?.items!.length == 1}" type="button" (click)="onRemoveItem(contenuto.id)" *ngIf="info?.items!.length !== 1">Rimuovi dato</button>
                    </div>
                </div>                      
            </div>
        </div>

        <hr class="mb-8" [ngClass]="{'mt-8': info?.items!.length != 1}">

        <div class="flex lg:flex-row flex-col gap-8">
            <div class="lg:w-1/3 w-full">
                <button class="btn-outln-backoffice p-3 w-full font-medium" type="button" (click)="onAddItem()">Aggiungi un dato</button>
            </div>
            <div class="lg:w-1/3 w-full">
                <p-confirmPopup #confirmPopupRef>
                    <ng-template pTemplate="headless" let-message>
                        <div class="border-round p-3">
                            <span class="text-base">{{ message.message }}</span>
                            <div class="flex align-items-center gap-2 mt-3">
                                <p-button class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDelete()" label="Elimina" />
                                <p-button class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onAnnulla()" label="Annulla" />
                            </div>
                        </div>
                    </ng-template>
                </p-confirmPopup>
                <button class="btn-danger-backoffice p-3 w-full font-medium" type="button" (click)="onDeletePopup($event)">Elimina la info</button>
            </div>
            <div class="lg:w-1/3 w-full">
                <button class="btn-outln-backoffice p-3 w-full font-medium" type="submit" [disabled]="!formInfo.valid">Salva Modifiche</button>                    
            </div>
        </div>
        
    </form>
</section>